import { render, staticRenderFns } from "./banner-stand-settings.vue?vue&type=template&id=3d3a495b"
import script from "./banner-stand-settings.vue?vue&type=script&lang=ts"
export * from "./banner-stand-settings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports